/**
 * 主动调起 RN App 方法
 * @param scene
 * @param params
 */
const rnapp = (scene, params = {}) => {
  let data = {
    scene: scene,
    params: params
  };
  window.ReactNativeWebView.postMessage(JSON.stringify(data));
};

export const globalNavigate = params => rnapp("rnRoute", params);
export const getUserInfo = back => {
  let params = {
    scene: "getUserInfo"
  };
  window.ReactNativeWebView.postMessage(JSON.stringify(params));
  window.RNJsBriageObject.setValue = back;
};

export const getShare = back => {
  window.RNJsBriageObject.setShare = back;
};

export const goRNRoute = url => {
  let params = {
    scene: "rnRoute",
    params: {
      url: url
    }
  };
  window.ReactNativeWebView.postMessage(JSON.stringify(params));
};

/**
 * 调 RN webview
 * @param params
 */
export const goWebview = (params) => {
  rnapp("goWebView", params);
};
/**
 * 设置状态栏字体颜色模式
 * @param statusTextColor black 黑色字体 white 白色字体
 */
export const setStatusTextColor = (statusTextColor = "black") => {
  rnapp("statusModel", {
    statusModel: statusTextColor
  });
  
};

/**
 * RN App 路由
 * @param params
 */
export const goNativeRoute = data => {
  let params = {
    scene: "nativeRouter",
    params: data
  };
  window.ReactNativeWebView.postMessage(JSON.stringify(params));
};
